// TaulukkoFooter (rich-text, MinimalLexical-based) expects its `caption`
// prop as either a plain string (treated as plain-text-only, no formatting)
// or a {value, html, lexicalId} object, and its onChange hands back
// {value, html, lexicalId}. Every v2 caption column is a plain SQL TEXT
// field, so a rich caption is persisted as JSON.stringify({value, html})
// and reconstructed on load. A bare string already in the column (or ''
// before anything's been typed) is passed straight through — TaulukkoFooter
// already treats a plain string as its own value/html fallback.
export function parseCaptionForEditor(raw) {
  if (!raw) return raw ?? '';
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object' && 'value' in parsed) return parsed;
  } catch { /* not JSON — a plain string, from before rich-text captions */ }
  return raw;
}

export function serializeCaptionForSave(capData) {
  return JSON.stringify({ value: capData?.value ?? '', html: capData?.html ?? '' });
}
